<template>
<div id="regcontent">
    <div id="evolve">Evolve</div>
    <div class="d-flex flex-row justify-content-between reg-header" >
        <div class="text-left title">
            <h4>Registration</h4>
            <p>Follow these 3 simple steps to complete your registration.</p>
        </div>
        
    </div>
    <router-view/>
</div>
</template>
<script>
export default {
    name: 'Registration',
    data(){
        return{
            name: null,
            email: null,
            uid: null
        }
    },
    beforeCreate: function() {
            this.$parent.showNavbar = false        
    }
}
</script>
<style scoped>
#evolve{
    font-family: GothamRndSSm-Light;
    font-size: 22px;
    color: black;
    margin: 0 0 0 1em;
    height: 5%;
    text-align: start;
    bottom: 0;
    text-anchor: end;
    padding-top: 3em;
}
#regcontent{
    height: 100%;
    width:90%;
    margin: auto;
    /*margin-top: 3em;*/
}
.graphic{
    transform: translateY(40%);
}
.title{
    margin-top: 3em;
}
.title h4{
    font-family: GothamBold;
    font-size: 18px;
    color: #686868;
    font-weight: normal;
}
.title p{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    color: #686868;
}
.reg-header{
    margin-left: 1.4em;
    margin-bottom: 2em;
}
@media (max-width: 700px){
    .graphic{
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Registration.vue